<template>
  <div>
    <section class="content-header">
      <h1>Invoice</h1>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#"> <i class="fa fa-dashboard"></i> Home </a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">Examples</a>
        </li>
        <li class="breadcrumb-item active">Invoice</li>
      </ol>
    </section>

    <div class="pad margin no-print">
      <div class="callout callout-warning" style="margin-bottom: 0 !important">
        <h4><i class="fa fa-info"></i> Note:</h4>
        This page has been enhanced for printing. Click the print button at the
        bottom of the invoice to test.
      </div>
    </div>

    <section class="invoice printableArea">
      <div class="row">
        <div class="col-12">
          <h2 class="page-header">
            INVOICE
            <span class="text-warning">
              <small class="font-weight-600">Bill NO: {{ model.id }}</small>
            </span>
            <small class="pull-right"
              >Date:
              {{ model.created_at | formatDate("MMMM Do YYYY hh:mm A") }}</small
            >
          </h2>
        </div>
      </div>

      <div class="row align-items-center invoice-info">
        <div class="col-md-3 invoice-col">
          From
          <address>
            <strong class="text-info">Brokerage Corp</strong>
            <br />1295 Boulevard Jules Poitras, Saint-Laurent <br />Montreal, QC
            H4N 1X5, CA
          </address>
        </div>

        <div class="col-md-3 invoice-col">
          To
          <address>
            <strong class="text-primary">{{
              model.user && model.user.name
            }}</strong>
            <br />
            {{ model.user && model.user.address }}
            <br />
            Phone: {{ model.user && model.user.phone }}
            <br />
            Email: {{ model.user && model.user.email }}
          </address>
        </div>

        <div class="col invoice-col">
          <div class="invoice-details row no-margin bg-dark">
            <div class="col-md-6 col-lg-4">
              <b>Invoice</b>
              #{{ model.id }}
            </div>
            <div class="col-md-6 col-lg-4">
              <b>Order ID:</b>
              {{ model.id }}
            </div>
            <div class="col-md-6 col-lg-4">
              <b>Payment Due:</b>
              {{ model.created_at | formatDate("MMMM Do YYYY hh:mm A") }}
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 table-responsive">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Plan</th>
                <th>Wallet to pay</th>
                <th class="left">Currency</th>
                <th class="right">Price</th>
                <th class="right">Fees</th>
                <th class="right">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="left strong">{{ model.plan.name }}</td>
                <td class="left">{{ model.wallet }}</td>
                <td class="left strong">{{ model.currency.name }}</td>
                <td class="right">
                  <h4 class="text-warning">{{ model.price }}</h4>
                </td>
                <td class="right">
                  <h4 class="text-warning">{{ model.fees }}</h4>
                </td>
                <td class="right">
                  <h4 class="text-primary">
                    {{ parseFloat(model.price) + parseFloat(model.fees) }}
                  </h4>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-6">
          <p class="lead">
            <b>Payment Due</b>
            <span class="text-warning">{{
              model.created_at | formatDate("MMMM Do YYYY hh:mm A")
            }}</span>
          </p>
          <p class="lead">
            <b>Payment Methods:</b>
            BTC
          </p>
        </div>

        <div class="col-12 col-sm-6 text-right">
          <table class="table table-clear">
            <tbody>
              <tr>
                <td class="left">
                  <strong>Subtotal</strong>
                </td>
                <td class="right">${{ model.plan.price }} USD</td>
              </tr>
              <tr>
                <td class="left">
                  <strong>Fees</strong>
                </td>
                <td class="right">${{ model.plan.fees }} USD</td>
              </tr>

              <tr>
                <td class="left">
                  <strong>Total</strong>
                </td>
                <td class="right">
                  <strong
                    >${{
                      parseFloat(model.plan.price + model.plan.fees)
                    }}
                    USD</strong
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row no-print">
        <div class="col-12">
          <button id="print" class="btn btn-success" type="button">
            <span> <i class="fa fa-print"></i> Print </span>
          </button>

          <button
            type="button"
            class="btn btn-success pull-right"
            style="margin-right: 5px"
          >
            <i class="fa fa-download"></i> Generate PDF
          </button>
        </div>
      </div>
    </section>
    <br />
    <br />
    <br />
    <div class="clearfix"></div>
  </div>
</template>

<script>
import { formatDate, formatDollar } from "@/filters";

export default {
  data() {
    return {
      type: "",
      loading: false,
      model: {
        user: {},
        currency: {},
        plan: {},
      },
    };
  },
  filters: { formatDate, formatDollar },
  created() {
    this.getData(this.$route.params.id);
  },
  methods: {
    getData(id) {
      this.loading = true;
      this.$http
        .get("/api/v1/client/invoices/" + id, {
          headers: {
            "content-type": "application/json",
            Authorization: this.$store.getters.authToken,
          },
        })
        .then((response) => {
          this.model = response.data;
          this.loading = false;
        })
        .catch((error) => {
          error.response.data &&
            error.response.data.map((m) => {
              this.$toasted.show(m, {
                position: "top-right",
                duration: 5000,
                type: "error",
                closeOnSwipe: true,
              });
            });
          this.loading = false;
        });
    },
  },
};
</script>
